import { render, staticRenderFns } from "./ClientePrazoPagamentoB2BEmpresaModal.vue?vue&type=template&id=1b4bc30e&scoped=true"
import script from "./ClientePrazoPagamentoB2BEmpresaModal.vue?vue&type=script&lang=js"
export * from "./ClientePrazoPagamentoB2BEmpresaModal.vue?vue&type=script&lang=js"
import style0 from "./ClientePrazoPagamentoB2BEmpresaModal.vue?vue&type=style&index=0&id=1b4bc30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4bc30e",
  null
  
)

export default component.exports